import asServedSets from './as-served-sets.json';
import audit from './audit.json';
import common from './common.json';
import dashboard from './dashboard.json';
import drinkwareSets from './drinkware-sets.json';
import faqs from './faqs.json';
import fdbs from './fdbs.json';
import feedbackSchemes from './feedback-schemes.json';
import guideImages from './guide-images.json';
import imageMaps from './image-maps.json';
import io from './io.json';
import jobs from './jobs.json';
import languages from './languages.json';
import locales from './locales.json';
import media from './media.json';
import notifications from './notifications.json';
import nutrientTables from './nutrient-tables.json';
import nutrientTypes from './nutrient-types.json';
import nutrientUnits from './nutrient-units.json';
import permissions from './permissions.json';
import roles from './roles.json';
import securables from './securables.json';
import signInLogs from './sign-in-logs.json';
import surveySchemePrompts from './survey-scheme-prompts.json';
import surveySchemes from './survey-schemes.json';
import surveys from './surveys.json';
import tasks from './tasks.json';
import user from './user.json';
import users from './users.json';

const messages = {
  common,
  dashboard,
  audit,
  'drinkware-sets': drinkwareSets,
  faqs,
  fdbs,
  'feedback-schemes': feedbackSchemes,
  'as-served-sets': asServedSets,
  'guide-images': guideImages,
  'image-maps': imageMaps,
  io,
  jobs,
  languages,
  locales,
  media,
  notifications,
  'nutrient-tables': nutrientTables,
  'nutrient-types': nutrientTypes,
  'nutrient-units': nutrientUnits,
  permissions,
  roles,
  securables,
  'sign-in-logs': signInLogs,
  'survey-schemes': surveySchemes,
  'survey-scheme-prompts': surveySchemePrompts,
  surveys,
  tasks,
  user,
  users,
};

export default messages;
